export default __webpack_public_path__ + "static/media/type.e9262efc.svg";